import { useState, useEffect } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileNav } from "@/components/MobileNav";
import { CartDrawer } from "@/components/CartDrawer";
import { SearchOverlay } from "@/components/SearchOverlay";
import { CookieConsent } from "@/components/CookieConsent";
import { trackView } from "@/lib/track";
import { captureAdRef } from "@/lib/ads";
import api, { SHOP_SUSPENDED_PATH } from "@/lib/api";

export const Layout = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const [suspended, setSuspended] = useState(false);

  // Boutique suspendue : la vitrine est fermée pour tout le monde, admins compris.
  // Le backend laisse passer les appels des admins (pour le back-office), donc
  // l'intercepteur API ne suffit pas à les rediriger ici.
  useEffect(() => {
    api.get("/subscription/status").then(({ data }) => setSuspended(!!data.blocked)).catch(() => {});
  }, [location.pathname]);

  useEffect(() => {
    trackView(location.pathname);
    captureAdRef(location.search, location.pathname);
  }, [location.pathname, location.search]);
  if (suspended) return <Navigate to={SHOP_SUSPENDED_PATH} replace />;

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <div data-testid="announce-bar" className="fixed top-0 z-50 w-full bg-ink text-cream text-center h-9 flex items-center justify-center px-4">
        <p className="text-[10px] md:text-xs uppercase tracking-[0.15em] font-light truncate">
          Déstockage en cours — jusqu'à <span className="text-gold font-medium">−70%</span>
          <span className="hidden sm:inline">&nbsp;&nbsp;·&nbsp;&nbsp;Livraison offerte dès 50&nbsp;€&nbsp;&nbsp;·&nbsp;&nbsp;Retours sous 15 jours</span>
        </p>
      </div>
      <Header onSearch={() => setSearchOpen(true)} />
      <main className="flex-1 pt-[100px] md:pt-[116px] pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileNav onSearch={() => setSearchOpen(true)} />
      <CartDrawer />
      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
      <CookieConsent />
    </div>
  );
};
